import Swiper from 'swiper/bundle';
import { swiperOptions } from './module/SwiperFunctions';

document.addEventListener('DOMContentLoaded', () => {
  // index
  if (document.querySelector('.swiper__courseIndex')) {
    new Swiper(
      '.swiper__courseIndex',
      swiperOptions({
        slidesPerView: 'auto',
        centeredSlides: false,
        loop: true,
        spaceBetween: 10,
        navigation: {
          nextEl: '.u-swiperButton__next',
          prevEl: '.u-swiperButton__prev',
          disabledClass: 'swiper-button-disabled',
        },
        breakpoints: {
          1024: {
            spaceBetween: 30,
          },
        },
      })
    );
  }
  // index
  if (document.querySelector('.recommendation__swiper')) {
    new Swiper(
      '.recommendation__swiper',
      swiperOptions({
        slidesPerView: 1,
        spaceBetween: 30,
        centeredSlides: true,
        navigation: {
          nextEl: '.u-swiperButton__next',
          prevEl: '.u-swiperButton__prev',
          disabledClass: 'swiper-button-disabled',
        },
      })
    );
  }
});
